import { createAction, createSetterActions } from "@/redux/helpers/action";

import { MODULE } from "./constants";

export const [setCurrentUser] = createSetterActions(MODULE, ["currentUser"]);

export const reset = createAction(`${MODULE}/RESET`);
